import httpRequest from '../../common/lib/http-request';

// *************************
// AUTHENTICATION SERVICES
// *************************

function validateUserData(userParameters) {
    return httpRequest({
        url: '/Registration/validate',
        method: 'POST',
        data: {
            userRef: Number(userParameters[0]),
            formId: Number(userParameters[1]),
            registrationRef: userParameters[2].toString()
        }
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const AuthenticationService = { validateUserData }

export default AuthenticationService;